
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Artworks } from 'components/artworks/Artworks';
import { Meta } from 'components/common/Meta';
import routes from 'constants/routes';
import type { Router } from 'instantsearch.js';
import { BaseLayout } from 'layouts/BaseLayout';
import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import singletonRouter from 'next/router';
import { ReactElement } from 'react';
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs';
const instantSearchRouter = createInstantSearchRouterNext({
    singletonRouter
}) as Router<unknown>;
const ArtworksPage = () => {
    const { t } = useTranslation();
    return (<>
      <Meta pageTitle={t('artworks:page_title')} pageDescription={t('artworks:page_desc')} imageName='social-artworks-page' relativeUrl={routes.artworks}/>

      <Artworks instantSearch={{ routing: { router: instantSearchRouter } }}/>
    </>);
};
ArtworksPage.getLayout = (page: ReactElement) => <BaseLayout>{page}</BaseLayout>;
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default ArtworksPage;

    async function __Next_Translate__getStaticProps__19cd74a82c3__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/artworks/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19cd74a82c3__ as getStaticProps }
  